import { render, staticRenderFns } from "./header_menu_mobile.vue?vue&type=template&id=e2fc7cbe&scoped=true&"
import script from "./header_menu_mobile.vue?vue&type=script&lang=js&"
export * from "./header_menu_mobile.vue?vue&type=script&lang=js&"
import style0 from "./header_menu_mobile.vue?vue&type=style&index=0&id=e2fc7cbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2fc7cbe",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BrazeWrapper: require('/var/web/bet777.es/components/braze-wrapper.vue').default})
